import type { IMaintenanceDowntimeCronDescription } from '$shared/interfaces/api/IMaintenanceDowntimeCronDescription';
import BaseModel from './BaseModel';

export class MaintenanceDowntimeCronDescription extends BaseModel<IMaintenanceDowntimeCronDescription> {
  public get expression(): string {
    return this.response?.expression;
  }

  public get description(): string {
    return this.response?.description;
  }

  public get isUnderMaintenanceInTheNextHour(): boolean {
    return !!this.response?.isUnderMaintenanceInTheNextHour;
  }

  public get trigger(): string {
    return this.response?.trigger;
  }

  public get isExpired(): boolean | undefined {
    return this.response?.isExpired;
  }

  public get isInMaintenance(): boolean {
    return this.isUnderMaintenanceInTheNextHour;
  }
}
